import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from '@a-type/ui';
export function ColorPicker({ value, onValueChange }) {
    const colors = [
        { value: 'lemon', label: 'Lemon' },
        { value: 'leek', label: 'Leek' },
        { value: 'blueberry', label: 'Blueberry' },
        { value: 'eggplant', label: 'Eggplant' },
        { value: 'tomato', label: 'Tomato' },
    ];
    return (_jsxs(Select, { value: value, onValueChange: onValueChange, items: colors, children: [_jsxs(Select.Trigger, { children: [_jsx(Select.Value, { children: (color) => _jsx(Swatch, { color: color }) }), _jsx(Select.Icon, {})] }), _jsx(Select.Content, { children: colors.map((color) => (_jsx(Select.Item, { value: color.value, children: _jsx(Swatch, { color: color.value }) }, color.value))) })] }));
}
const Swatch = ({ color }) => (_jsx("div", { style: {
        width: 16,
        height: 16,
        backgroundColor: 'var(--m-tint)',
        borderRadius: 4,
    }, className: `@mode-${color}`, "aria-label": color }));
//# sourceMappingURL=ColorPicker.js.map